import { SecurityContextTemplate } from 'framework/authorization';
import React from 'react';
import { ResourceId } from 'framework/crud';
import { Permission } from 'framework/authorization';
import UrlTokenProvider from './UrlTokenProvider';

export type Service = {
  getPermissions: () => Permission[];
};

type TmpAccessAwareSecurityContextProps = {
  children: React.ReactNode | React.ReactNode[];
  contextName: string;
  // eslint-disable-next-line react/require-default-props
  id?: ResourceId;
  // eslint-disable-next-line react/require-default-props
  idSource?: string;
  permissionToCheck: Permission | Permission[] | null;
  useEntityService: () => Service;
};

const Wrapper = ({ useEntityService, ...props }: TmpAccessAwareSecurityContextProps) => {
  const { getPermissions } = useEntityService();

  return <SecurityContextTemplate getPermissionsFunc={getPermissions} {...props} />;
};

const TmpAccessAwareSecurityContext = (props: TmpAccessAwareSecurityContextProps) => {
  return (
    <UrlTokenProvider>
      <Wrapper {...props} />
    </UrlTokenProvider>
  );
};

export default TmpAccessAwareSecurityContext;
